module.exports = __webpack_public_path__ + "img/emun.db83faf8.png";